import React from 'react'
import TableHeader from '../../../../components/table/TableHeader'
import Text from '../../../../components/text/Text'
import TableLayout from '../../../../components/table/TableLayout'
import {IPostList} from '../../../../apis/post/getPostList'
import WizImage from '../../../../components/image/WizImage'
import {useImage} from '../../../../utils/image'
import {useTime} from '../../../../utils/time'
import useNavigation from '../../../../hooks/useNavigation'
import WizTag from '../../../../components/tag/WizTag'
import CheckTableItem from '../../../../components/table/CheckTableItem'
import Span from '../../../../components/text/Span'

interface IProps {
    className?: string
    data?: IPostList[]
    onChecked?: (e?: any) => void
    checkList?: any[]
}

const PostListTable: React.FC<IProps> = ({className, data, onChecked, checkList}) => {
    const {renderThumbnail} = useImage()
    const {localTimeString} = useTime()
    const {goPostDetail, goUserDetail} = useNavigation()
    const checkScamPost = (list: IPostList) => {
        if (!list?.user.name.match('League of Traders') && (list?.content.match('http') || list?.title.match('http'))) {
            return true
        }
    }

    const onClickListItem = (list?: IPostList) => {
        goPostDetail(list?.id)
    }

    return (
        <div className={`${className}`}>
            <TableHeader
                className={
                    'grid-cols-[250px_auto_150px_150px_190px] md:grid-cols-[200px_1fr_170px] md:hidden pl-[40px] pr-[30px]'
                }>
                <Text>Writer</Text>
                <Text>Title/Content</Text>
                <Text className={'md:hidden'}>Interactions</Text>
                <Text className={'md:hidden'}>Image</Text>
                <Text>Create At</Text>
            </TableHeader>
            <TableLayout>
                {data?.map(list => (
                    <CheckTableItem
                        onClick={() => onClickListItem(list)}
                        key={list?.id}
                        checked={checkList?.find(item => item === list?.id)}
                        onChecked={() => onChecked(list?.id)}
                        className={
                            'grid-cols-[250px_1fr_150px_150px_190px] lg:grid-cols-[200px_1fr_150px_170px] md:block !gap-[12px]'
                        }>
                        <div
                            className={'flex space-x-[10px] items-center'}
                            onClick={e => {
                                e.stopPropagation()
                                goUserDetail(list?.user?.id)
                            }}>
                            <div
                                className={
                                    list?.user?.is_filtered && 'border-[2px] border-font_red rounded-full flex-none'
                                }>
                                <WizImage
                                    src={renderThumbnail(list?.user.thumbnail)}
                                    className={'w-[36px] h-[36px] rounded-full'}
                                />
                            </div>
                            <div className={'truncate'}>
                                <Text className={`text-ti2 ${list?.user?.is_filtered && 'text-font_red'} truncate`}>
                                    {list?.user.name}
                                </Text>
                                <Text className={'hidden md:block md:text-font03 md:text-body3'}>
                                    {localTimeString(list?.created_at)}
                                </Text>
                            </div>
                            {list?.user?.is_filtered && (
                                <div className={'bg-shadow_ban px-[5px] py-[1px] rounded-[3px]'}>
                                    <Text className={'text-ti3 text-white'}>Ban</Text>
                                </div>
                            )}
                        </div>
                        <div className={'space-y-[10px] truncate md:mt-[20px] md:pl-[46px]'}>
                            <Text className={`text-ti2 md:text-ti1 ${checkScamPost(list) && 'text-font_red'}`}>
                                {list?.title}
                            </Text>
                            <div className={'flex items-center'}>
                                <Text className={'truncate text-body2 text-font02'}>{list?.content}</Text>
                                {checkScamPost(list) && <WizTag state={false}>Scam</WizTag>}
                            </div>
                        </div>
                        <div className={'flex gap-x-[12px]'}>
                            <Text>
                                ❤️{'  '}
                                <Span className={`${list?.likes_count === 0 ? 'text-font03' : 'text-font01'} text-ti2`}>
                                    {list?.likes_count}
                                </Span>
                            </Text>
                            <Text>
                                💬{'  '}
                                <Span
                                    className={`${
                                        list?.comments_count === 0 ? 'text-font03' : 'text-font01'
                                    } text-ti2`}>
                                    {list?.comments_count}
                                </Span>
                            </Text>
                        </div>
                        <div className={'flex space-x-[5px] items-center justify-start md:hidden'}>
                            {list?.images &&
                                list?.images
                                    ?.slice(0, 3)
                                    .map(image => (
                                        <WizImage
                                            src={`${image}?type=webp&width=500&quality=100`}
                                            className={'max-w-[50px] rounded-[3px]'}
                                        />
                                    ))}
                        </div>
                        <div>
                            <Text className={'text-body2 text-font02 md:hidden'}>
                                {localTimeString(list?.created_at)}
                            </Text>
                        </div>
                    </CheckTableItem>
                ))}
            </TableLayout>
        </div>
    )
}

export default PostListTable
